import { sounds } from "@/utils/Sounds";
import type { SpineLayout } from "@pixi/spine-layout";

const FINISH_HIDE_DELAY_MS = 1500;

export class TrackController {
    private finishHideTimeout?: ReturnType<typeof setTimeout>;

    constructor(private layout: SpineLayout) {
        this.layout?.playAnimationByName('init');
    }

    prepareForTheRace() {
        this.layout.getAnimationsStates().forEach((state) => this.layout.stopState(state, false));

        this.layout.playAnimationByName('prepare');
    }

    showStartLine() {
        this.layout.playAnimationByName('prepare');
    }

    async startCountDown() {
        this.layout.playAnimationByName('prepare');
        sounds.playFX('count');
        await this.layout.playAnimationByName('count');
    }

    start() {
        this.layout.playAnimationByName('start');
    }

    move() {
        this.layout.playState('active');
    }

    stopMove() {
        this.layout.stopState('active');
    }

    async finish() {
        await this.layout.playState('finish');
        this.pause();
        this.layout.pauseAnimation('track', 'state_finish/finish');

        this.clearFinishHideTimeout();
        this.finishHideTimeout = setTimeout(() => {
            this.finishHideTimeout = undefined;
            void this.hide();
        }, FINISH_HIDE_DELAY_MS);
    }

    pause() {
        this.layout.getAnimationsStates().forEach((state) => this.layout.pauseState(state));
    }

    stop() {
        this.layout.getAnimationsStates().forEach((state) => this.layout.stopState(state, false));
    }

    async hide(force = false) {
        this.clearFinishHideTimeout();

        if (force) {
            await this.layout?.playAnimationByName('hideGameStatic', false, 1);
        } else {
            await this.layout?.playAnimationByName('hideGame', false, 2);
        }
    }

    async show() {
        this.clearFinishHideTimeout();
        this.layout.resetAnimation('track', 'state_finish/finish');
        this.stopMove();
        await this.layout?.playAnimationByName('showGame', false, 2);
    }

    private clearFinishHideTimeout() {
        if (this.finishHideTimeout !== undefined) {
            clearTimeout(this.finishHideTimeout);
            this.finishHideTimeout = undefined;
        }
    }
}
